var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"ui-typography",class:[
    `ui-typography--${_vm.variant}`,
    `ui-typography--${_vm.tone}`
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }